export const SAVE_LOGIN_USER = 'SAVE_LOGIN_USER'
export const LOGOUT_USER = 'LOGOUT_USER'
export const GET_ORDERS_IN_TO_CART = 'GET_ORDERS_IN_TO_CART'
export const GET_LANGUAGE = 'GET_LANGUAGE'
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS'
export const SAVE_LOCATION = 'SAVE_LOCATION'
export const SAVE_SEARCH = 'SAVE_SEARCH'
